<template lang="jade">
  .container-fluid
    .row
      .schedule_main.col-md-12
        header.schedule_titile_bar.main_title_bar.clearfix
          h1.title.col-md-12.col-sm-10.col-xs-12
            | schedule
            span.deviceTime.col-md-3.pull-right.no_pad
              |{{deviceTime}}
        section.animation.clearfix(v-if="showAni")
          .spinner-wrap
            .spinner
              -for (var i =0; i <12; i++)
                i
        section.schedule_pagination.clearfix(v-if="!showAni")
          .col-md-8.col-sm-8.col-centered
            .btn-group.col-centered
              button.btn.btn-default(v-on:click="getSchedule(1)" v-bind:class="{'focus': pageFocus === 1}")
                span 1
              button.btn.btn-default(v-on:click="getSchedule(2)" v-bind:class="{'focus': pageFocus === 2}")
                span 2
        section.schedule_content.clearfix(v-if="!showAni")
          table.table.table-bordered.schedule_table.hidden-md.hidden-lg
            tr
              th No.
              th Enable
              th Name
              th
            tr(v-for="(key ,schedule) in schedules" )
              td {{ key }}
              td
                i.fa.fa-check-square.fa-lg(v-if='schedule.enabled' v-on:click='setSchedule(false, key)')
                i.fa.fa-square-o.fa-lg(v-else v-on:click='setSchedule(true, key)')
              td {{ schedule.name }}
              td
                span(v-on:click='toShowModal(key)')
                  i.fa.fa-edit
          table.table.table-bordered.table-striped.table-hover.schedule_table.hidden-sm.hidden-xs
            tr
              th No.
              th Enable
              th Name
              th I/O
              th Actions
              th Time
              th Days
              th
            tr(v-for="(key, schedule) in schedules")
              td {{ key }}
              td
                i.fa.fa-check-square.fa-lg(v-if='schedule.enabled' v-on:click='setSchedule(false, key)')
                i.fa.fa-square-o.fa-lg(v-else v-on:click='setSchedule(true, key)')
              td {{ schedule.name }}
              td.banks
                .no_pad(v-for="(key, bank) in allBanks" v-if="schedule.banks.indexOf(key.toString()) !== -1")
                  span
                    | {{key === 0 ? 'Input' : 'Outlet' + key}}
              td {{ schedule.action }}
              td {{ schedule.time.hours.toString().length === 1 ? '0' + schedule.time.hours : schedule.time.hours }}:{{schedule.time.minutes.toString().length === 1 ? '0'+schedule.time.minutes : schedule.time.minutes }}
              td.weekDay
                span.day(v-for='(key,day) in weekDay' v-bind:class="{enabled:schedule.time.days.indexOf(day) !== -1}")
                  | {{ day }}
              td
                span(v-on:click='toShowModal(key)')
                  i.fa.fa-edit.fa-lg
  modal.popout.schedule_config(
    v-bind:show.sync='showModal'
    v-bind:title='editing.title'
    effect='zoom'
    v-bind:callback='handleScheduleConfig'
    ok-text="Apply"
    cancel-text="Cancel")
    .modal-body(slot="modal-body")
      table.table.table-bordered.schedule_config_table
        tr
          th Enable
          td.enabled
            input(type="checkbox" v-model="editing.schedule.enabled" id='schedule{{editing.schedule.no}}')
            label(for="schedule{{editing.schedule.no}}")
              i.fa.fa-check-square.fa-lg(v-show='editing.schedule.enabled')
              i.fa.fa-square-o.fa-lg(v-else)
        tr
          th Name
          td
            validator(name='scheName')
              input.form-control(type="text" v-model="new_schedule_name"
                    v-bind:value="editing.schedule.name" maxLength='7' v-validate:name="['engAndNum']")
              span.error(v-show='$scheName.name.invalid && $scheName.name.modified')
                |English Charactor ,numbers and '_' only
        tr
          th I/O
          td.banks.col-xs-10
            v-multi-banks(v-bind:name-prop="'bank'"
                          v-bind:options='targetOption'
                          v-bind:output-ary.sync='editing.newBanks'
                          v-bind:show-all-outlet-btn="true")
        tr
          th Actions
          td
            v-select(v-bind:options.sync="actionOptions"
                     v-bind:value.sync='editing.schedule.action')
        tr
          th Time
          td.time.col-xs-10
            input.form-control-inline(type='number' max='23' min='0' v-model='editing.schedule.time.hours')
            span &nbsp;:&nbsp;
            input.form-control-inline(type='number' max="59" min='0' v-model='editing.schedule.time.minutes')
        tr
          th Days
          td.weekDay
            v-multi-banks(v-bind:name-prop="'weekDay'"
                          v-bind:options='weekOption'
                          v-bind:output-ary.sync='editing.newDays'
            )
            //- span.clearfix(v-for='(key,day) in weekDay')
            //-   input.weekDay_checkbox(type="checkbox" value='{{day}}' v-bind:checked="editing.schedule.time.days.indexOf(day) !== -1" id="{{day}}{{key}}" v-model='editing.newDays')
            //-   label.weekDay_label(for="{{day}}{{key}}") {{ day }}

</template>

<script>
import { modal } from 'vue-strap'
import _ from 'lodash'
import select from 'src/components/Single-Select.vue'
import { call } from 'src/Service.js'
import multiBanks from 'src/components/Multi-Banks.vue'
import $ from 'jquery'
import moment from 'moment'
const DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss'

export default {
  components: {
    modal,
    'v-select': select,
    'v-multi-banks': multiBanks
  },
  data () {
    return {
      editing: {
        title: 'Schedule Config',
        index: '',
        schedule: null,
        newBanks: [],
        newDays: []
      },
      schedules: {},
      banks: {},
      input: {},
      allBanks: [],
      showModal: false,
      new_schedule_name: '',
      weekDay: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
      actionOptions: [
        {label: 'Power ON', value: 'Power ON'},
        {label: 'Power OFF', value: 'Power OFF'},
        {label: 'Power RESET', value: 'Power RESET'},
        {label: 'Sequence ON (From Outlet 1 to 9)', value: 'Sequence ON'},
        {label: 'Sequence OFF (From Outlet 1 to 9)', value: 'Sequence OFF'}
      ],
      currentTime: '',
      timezone: {},
      pageFocus: 1,
      showAni: true
    }
  }, // close data
  computed: {
    scheduleLength () {
      return Object.keys(this.schedules).length
    },
    deviceTime () {
      if (this.timezone.useDaylight && moment().isDST()) {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT)
      } else {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT)
      }
    },
    targetOption () {
      return Object.keys(this.allBanks).map(idx => {
        return {
          label: idx === '0' ? 'Input' : 'Outlet' + idx,
          value: idx
        }
      })
    },
    weekOption () {
      return this.weekDay.map(day => {
        return {
          label: day,
          value: day
        }
      })
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    this.showAni = true
    call(mac, 'dxGetSchedules', { key: 1 }).then(({entries}) => {
      this.schedules = _.cloneDeep(entries)
      return call(mac, 'dxGetPowerStatus')
    }).then(({banks, input}) => {
      this.banks = _.cloneDeep(banks)
      this.input = _.cloneDeep(input)
      this.allBanks = []
      this.allBanks.push(this.input)
      for (let key of Object.keys(this.banks)) {
        this.allBanks.push(this.banks[key])
      }
      return call(mac, 'dxGetTimeZone')
    }).then(({timezone}) => {
      this.timezone = timezone
      this.showAni = false
    }).catch(err => {
      this.alert('danger', 'Error', 'Unexpect error when initializing the page')
      console.log(err)
    })
  },
  methods: {
    getSchedule (page) {
      let { mac } = this.$route.params
      this.showAni = true
      call(mac, 'dxGetSchedules', { key: page }).then(({entries}) => {
        this.schedules = _.cloneDeep(entries)
        this.pageFocus = page
        this.showAni = false
      }).catch(err => {
        this.alert('danger', 'Error', 'Unexpect error when initializing the page')
        this.schedule = []
        this.showAni = false
        console.log(err)
      })
    },
    updateTime () {
      this.currentTime = Date.now()
      let vue = this
      setTimeout(function () {
        vue.updateTime()
      }, 1000)
    },
    alert (type, title, content) {
      this.$dispatch('alert', {
        type: type,
        title: title,
        content: content
      })
    },
    setSchedule (enabled, scheduleKey) {
      let param = {
        entries: {
          [scheduleKey]: this.schedules[scheduleKey]
        }
      }
      param.entries[scheduleKey].enabled = enabled
      call(this.$route.params.mac, 'dxSetSchedules', param).then(res => {
        console.log(res)
      }, err => {
        this.alert('danger', 'Unexpected Error', err)
        console.log(err)
      })
    },
    toShowModal (key) {
      this.editing.index = key
      this.editing.title = 'Schedule Config ' + key
      this.editing.schedule = _.cloneDeep(this.schedules[key])
      this.editing.newBanks = this.editing.schedule.banks
      this.editing.newDays = this.editing.schedule.time.days
      this.showModal = true
    },
    handleScheduleConfig () {
      // validation
      if (this.$scheName.invalid) return this.alert('danger', '', 'Please enter a valid schedule name')

      // Time validation
      let regexNum = /^[0-9]{1,2}/
      if (!regexNum.test(this.editing.schedule.time.hours) || !regexNum.test(this.editing.schedule.time.minutes) || this.editing.schedule.time.hours.length > 2 || this.editing.schedule.time.minutes.length > 2) return this.alert('danger', '', 'Please enter valid times')

      if (this.editing.schedule.time.hours < 0 || this.editing.schedule.time.minutes < 0 || this.editing.schedule.time.hours > 23 || this.editing.schedule.time.minutes > 59) {
        return this.alert('danger', '', 'Please enter right format of time (ex: 14:59)')
      }

      // Need at least a day to activate schedule
      if (this.editing.newDays.length === 0) {
        return this.alert('danger', '', 'Please choose a day for your schedule to active')
      }

      // Schedule must have a target
      if (this.editing.newBanks.length === 0) {
        return this.alert('danger', '', 'Please give your schedule a target')
      }

      // Sequence ON or Sequence OFF must have all targets
      if (this.editing.newBanks.length !== this.allBanks.length && (this.editing.schedule.action === 'Sequence ON' || this.editing.schedule.action === 'Sequence OFF')) {
        return this.alert('danger', '', 'You need to select all targets to enable Sequence ON/Sequence OFF')
      }

      let sche = _.cloneDeep(this.editing.schedule)
      sche.name = this.new_schedule_name.trim() // trim ' ' of the both sides
      sche.banks = _.cloneDeep(this.editing.newBanks)
      sche.time.days = _.cloneDeep(this.editing.newDays)

      let param = {
        entries: {
          [this.editing.index]: sche
        }
      }

      call(this.$route.params.mac, 'dxSetSchedules', param).then(res => {
        console.log(res)
        this.showModal = false
      }, err => {
        this.alert('danger', 'Unexpected Error', err)
        console.log(err)
      })
    }
  },
  ready () {
    this.updateTime()
  },
  events: {
    update (mac, {type, event, msg}) {
      // update the data when received
      console.log(type)
      console.log(event)
      console.log(msg)
      if (type === 'schedule') {
        this.schedules = _.assignIn(this.schedules, event)
      } else if (type === 'timezone') {
        this.timezone = event.timezone
      }
    }
  },
  watch: {
    'editing.schedule.action' (nV) {
      console.log(nV)
      if (nV === 'Sequence ON' || nV === 'Sequence OFF') {
        this.editing.newBanks = []
        for (let i = 0; i < this.allBanks.length; i++) {
          this.editing.newBanks.push(i.toString())
        }
        // this.editing.newBanks = ['0', '1', '2', '3']
      }
    },
    showModal (nv) {
      if (!nv) {
        $('.schedule_config').scrollTop(0)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>
  @import '~__vendor_variables_scss__';
  @import '~sass/_breakpoint.scss';
  table th {
    text-align: center;
  }
  .schedule_table {
    max-width:1388px;
    margin-left: auto;
    margin-right: auto;
    margin-top: $space_sm;
    text-align: center;
    & th{
      text-align: center;
    }
    .banks{
      padding-top: 0;
      text-align: center;
      max-width: 400px;
      & > div{
        max-width: 80px;
        margin-top: 5px;
        float: left;
        & span{
          padding-left: 7px;
          padding-right: 7px;
          // background-color: darken($outlet_color, 20%);
          // border:1px solid darken($outlet_color, 20%);
          color: $GLOBAL_fg;
          text-align: center;
          position: relative;
          &:after{
            display:block;
            position: absolute;
            top: 5px;
            right: 0px;
            transform-origin:center;
            transform: rotateZ(15deg);
            width: 2px;
            height: 22px;
            content: '';
            // height: 100%;
            border-right: 1px solid $GLOBAL_comment_fg;
          }
        }
        &:last-child span:after{
          display: none;
        }
      }

      span{
        padding: 5px 7px;
        // color: $base_white;
        border-radius: $base_border_radius;
        white-space: nowrap;
      }
    }
    .weekDay{
      & .day{
        text-transform: uppercase;
        padding-left: 5px;
        padding-right: 5px;
        opacity: .3;
        &.enabled{
          opacity: 1;
        }
      }
    }
  }
  .schedule_config_table{
    th {
      text-transform: capitalize;
    }
    /* ============ global weekDay and outlets style ==================== */
    .weekDay,.banks{
      width: 100%;
      position: relative;
      span{
        float: left;
        font-size: 14px;
        padding-left: 5px;
        padding-right: 5px;
        text-transform: uppercase;
      }
      label{
        cursor: pointer;
      }
    }
    .enabled{
      position: relative;
      padding-left: 30px;
      input{
        position: absolute;
        left: -9999px;
      }
      .fa{
        position: absolute;
        left: 10px;
        top: 10px;
      }
    }
    /* =========== outlets ======================= */
    .bank_checkbox{
      position: absolute;
      left: -9999px;
    }

    /* =========== weekDay ================== */
    // [FIXME] unused?
    .weekDay_checkbox{
      position: absolute;
      left: -9999px;
      &:checked + .weekDay_label{
        background-color: $base_black;
      }
    }
    .weekDay_label,.bank_label{
      width: 100%;
      padding: 5px 3px;
      background-color: #f00;
      color: $base_white;
    }

    .weekDay_label {
      @include breakpoint(lg){
        padding: 10px 8px;
        font-size: 14px;
      }
      @include breakpoint(md){
        padding: 10px 8px;
        font-size: 14px;
      }
    }
    /* ========== time ===================== */
    // .time{
    //   & input[type=number]::-webkit-inner-spin-button,
    //   & input[type=number]::-webkit-outer-spin-button{
    //     -webkit-appearance: none;
    //     appearance: none;
    //     margin: 0;
    //   }
    //   & input[type=number]{
    //     -moz-appearance: textfield;
    //   }
    // }
  }
  .popout.schedule_config{
    & td.banks, & td.weekDay{
      padding-left: 0;
    }
  }

  .schedule_pagination{
    padding-top:15px;
    margin-bottom: -7px;
    text-align: center;
    .btn{
      outline:none;
    }
    .btn-group{
      & .focus{
        background-color: #4a4b4a;
        color: #fff;
      }
    }
  }

// loading animation
.animation{
  position: relative;
  text-align: center;
  padding: 80px 1px 1px 1px;
  @include breakpoint(xxs) {
    padding: 30px 1px 1px 1px;
  }
}

.spinner {
  $desktopOffset: 30px;
  $mobileOffset: 20px;
  $basicOpacity: 1 / 12;
  $basicDeg: 30deg;
  // outline: 1px solid #f00;
  height: 100px;
  width: 100px;
  display: block;
  animation: spin 1s steps(12, end) infinite;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  transform-origin:center;
  & i {
    height: 30px;
    width: 6px;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    transform-origin: center;
    background: #000;
    box-shadow: 0 0 3px rgba(255, 255, 255, .7);
    border-radius: 3px;
    @for $i from 1 through 12 {
      &:nth-child(#{$i}){transform:rotate(($i - 1) * $basicDeg) translateY($desktopOffset); opacity: $basicOpacity * $i;}
    }
  }
  @include breakpoint(xxs) {
    & i {
      display:block;
      height: 30px;
      width: 4px;
      @for $i from 1 through 12 {
        &:nth-child(#{$i}){transform:rotate(($i - 1) * $basicDeg) translateY($mobileOffset) scale(.6, .6); opacity: $basicOpacity * $i ;}
      }
    }
    & i {
      transform: scale(.3, .3);
    }
  }
}


@keyframes spin {
  from { transform: rotateZ(0deg); }
  to { transform: rotateZ(360deg); }
}
</style>



// WEBPACK FOOTER //
// Schedule.vue?f651509e